module.exports = __webpack_public_path__ + "media/images/city/058-pyramid-e3bd186588b5f304884ed67082566498.svg";